import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";
import { BiMenuAltRight, BiSearchAlt } from "react-icons/bi";
import { MdOutlineShoppingCart, MdHistory } from "react-icons/md";
import { AiOutlineUser } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from "./Firebase";
import HeaderUserSubComponent from "../subComponent/HeaderUserSubComponent";
import axios from "axios";

const Header = () => {
  const {
    sidebarOpened,
    setSidebarOpened,
    cartItem,
    setCartItem,
    user,
    setUser,
    showSearch,
    setShowSearch,
    userName,
    getUserNameDetails,
  } = useStateContext();
  const navigate = useNavigate();
  const [search, setSearch] = useState();
  const [inputHover, setInputHover] = useState(false);
  const [products, setProducts] = useState();
  const [filteredProducts, setFilteredProducts] = useState();

  const getAllProducts = () => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/products`)
      .then((res) => setProducts(res.data));
  };

  useEffect(() => {
    console.log(products);
    const filtered = products?.filter((item) =>
      item.descr?.toLowerCase().includes(search?.toLowerCase())
    );
    setFilteredProducts(filtered);
    console.log(filtered);
  }, [search]);

  useEffect(() => {
    getAllProducts();
    // get cart from local Storage
    let cart = JSON.parse(localStorage.getItem("cartitems"));
    setCartItem(cart);

    // Listen for changes in authentication state
    const functofcurrentUser = onAuthStateChanged(
      firebaseAuth,
      (currentUser) => {
        setUser(currentUser);
        console.log(currentUser);
      }
    );

    if (user) {
      getUserNameDetails(user.email);
    }
    return () => {
      functofcurrentUser();
    };
  }, [user]);

  const handleSearchInput = () => {
    setShowSearch(true);
    if (search) {
      navigate(`/searchpage/${search}`);
      setSearch("");
      setShowSearch(false);
    }
  };

  return (
    <Components>
      {/* Logo */}
      <Logo className="bigScreen">
        <motion.div
          initial={{ height: "17rem" }}
          animate={{ height: "8rem" }}
          transition={{ type: "spring", duration: 1, delay: 0.8 }}
          media={{
            "(max-width: 470px)": { height: "7rem" },
            "(max-width: 400px)": { height: "4rem" },
            // Add more media queries and corresponding styles/animations as needed
          }}
        >
          <Link to="/">
            <h1>
              Ma<span style={{ color: "pink" }}>t</span>rix
            </h1>
          </Link>
        </motion.div>
      </Logo>

      {/* Responsive Logo */}
      <Logo className="responsive">
        <Link to="/">
          <h1>
            Ma<span style={{ color: "pink" }}>t</span>rix
          </h1>
        </Link>
      </Logo>

      {/* Right Sidebar */}
      <motion.div
        initial={{ height: "7rem" }}
        animate={{ height: "17px" }}
        transition={{ type: "spring", duration: 1, delay: 0.8 }}
      >
        <RightSidebar
          style={{
            color: `${showSearch ? "#c6c6c6" : "black"}`,
          }}
        >
          {/* Search Bar */}
          <SearchBar showSearch={showSearch}>
            <form
              onSubmit={handleSearchInput}
              className="form"
              style={{
                marginRight: `${showSearch ? "40px" : "0px"}`,
                background: `${showSearch ? "#ffffff" : "transparent"}`,
                border: `${showSearch ? "1px solid #daa3d2" : "none"}`,
              }}
            >
              <button
                onFocus={() => setShowSearch(true)}
                style={{ padding: `${showSearch ? "2px" : "0px"}` }}
              >
                <BiSearchAlt
                  style={{
                    marginRight: `${showSearch ? "0px" : "40px"}`,
                    fontSize: "24px",
                  }}
                  onClick={handleSearchInput}
                />
              </button>

              <input
                type="text"
                onMouseEnter={() => setInputHover(true)}
                onMouseLeave={() => setInputHover(false)}
                // onBlur={() => {
                //   setShowSearch(false);
                //   setInputHover(false);
                // }}
                style={{
                  width: `${showSearch ? "30vw" : "0vw"}`,
                  display: `${showSearch ? "flex" : "none"}`,
                }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </form>
            {
                search && showSearch ?
              <FilterContainer>
            
              {filteredProducts?.map((item) => (

                <div className="rowSearchOpt"  onClick={() => navigate(`/itemdetails/${item.prod_id}/${item.categories_id}`)} >
                  <div className="imageContainer">
                    <img src={item?.image} alt="" srcset="" />
                  </div>
                  <div className="description">{item?.descr}</div>
                </div>
              ))}    
            </FilterContainer> :  ""  }
         
          </SearchBar>

          {/* History */}
          <HeaderIconContainer>
            <MdHistory
              style={{ marginRight: 40 }}
              onClick={() => navigate("/orders")}
            />
            <Info style={{ color: "black" }}>History</Info>
          </HeaderIconContainer>

          {/* User */}
          <HeaderIconContainer>
            <AiOutlineUser
              style={{ marginRight: 40 }}
              onClick={() => navigate("/login")}
            />
            <Info
              style={{
                left: -98,
                width: 240,
                height: "auto",
                backgroundColor: "#ffff",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <p>
                {" "}
                <HeaderUserSubComponent user={userName} />{" "}
              </p>
            </Info>
            {!user && (
              <Number onClick={() => navigate("/login")}>
                <p style={{ color: "black" }}>?</p>
              </Number>
            )}
          </HeaderIconContainer>

          {/* Cart */}
          <Cart>
            <MdOutlineShoppingCart
              style={{ marginRight: 40 }}
              onClick={() => navigate("/cart")}
            />
            <Info style={{ color: "black" }}>Cart</Info>

            {cartItem && (
              <CartNumber>
                <p onClick={() => navigate("/cart")} style={{ color: "black" }}>
                  {cartItem.length}
                </p>
              </CartNumber>
            )}
          </Cart>
          {/* <SideBar /> */}

          <BiMenuAltRight onClick={() => setSidebarOpened(!sidebarOpened)} />
        </RightSidebar>
      </motion.div>
    </Components>
  );
};

export default Header;

const Components = styled.div`
  background-color: transparent;
  margin: 0px 40px;
  height: 10vh;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .responsive {
    display: none;
    @media (max-width: 470px) {
      display: flex;
    }
  }
  .bigScreen {
    display: flex;
    @media (max-width: 470px) {
      display: none;
    }
  }
  @media (max-width: 580px) {
    margin: 0px 30px;
  }

  @media (max-width: 470px) {
    margin: 0px 20px;
  }
  @media (max-width: 400px) {
    margin: 0px 10px;
  }
`;

const FilterContainer = styled.div`
  position: absolute;
  background-color: #fff;
  height: 40vh;
  overflow-y: scroll !important;

  width: 100%;
  bottom: -270px;
  padding: 10px 2px;
  @media (max-width: 470px) {
    width: 90%;
  }
  .rowSearchOpt {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    padding-bottom: 4px;
    border-bottom: 1px solid #ede9e9;

    :hover {
      background-color: #eaeaea;
    }
  }
  .imageContainer {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    img {
      width: 70px;
      height: 70px;
      object-fit: contain;
    }
  }
  .description {
    font-size: 12px;
    color: #151414;
  }
`;

const Logo = styled(motion.div)`
  font-family: "Lobster", cursive;
  font-size: 24px;

  @media (max-width: 580px) {
    font-size: 20px;
  }

  @media (max-width: 470px) {
    font-size: 17px;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
  cursor: pointer;
  a {
    text-decoration: none;
    color: black;
  }
`;
const RightSidebar = styled.div`
  display: flex;

  cursor: pointer;
  > * {
    font-size: 24px;
  }
`;

const GlowAnimation = keyframes`
0% {
 opacity: 0

}
100% {
  opacity: 1;
  background: #e63094;
  color: white;
  
}
`;

const Number = styled.div`
  width: 17px;
  height: 17px;
  position: absolute;
  top: -7px;
  right: 27px;
  border-radius: 50%;
  background: #f1bbd9;
  border: 2.7px solid #f2ebeb;
  display: flex;
  align-items: center;
  justify-content: center;
  animation-name: ${GlowAnimation};
  animation-duration: 4s;
  animation-iteration-count: infinite;
  p {
    font-size: 15px;
  }
`;

const CartNumber = styled.div`
  width: 17px;
  height: 17px;
  position: absolute;
  top: -7px;
  right: 27px;
  border-radius: 50%;
  background: #f1bbd9;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2.7px solid #f2ebeb;
  @media (max-width: 440px) {
    top: -9px;
    right: 7px;
  }
  p {
    font-size: 15px;
  }
`;

const SearchBar = styled.div`
  position: relative;
  @media (max-width: 470px) {
    position: relative;
    z-index: 1500;
    top: ${(props) => (props.showSearch ? "40px" : "0px")};
    left: ${(props) => (props.showSearch ? "-70px" : "0px")};
  }
  .form {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease-in-out;
    border-radius: 4px;
    @media (max-width: 470px) {
    }
    @media (max-width: 470px) {
      svg {
        margin-right: 17px !important;
      }
    }
    button {
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      margin-right: 4px;
      cursor: pointer;
      &:focus {
        outline: none;
      }
    }
  }
  input {
    height: 24px;
    font-size: 15px;
    outline: none;
    border: none;
    @media (max-width: 470px) {
      padding: 0.3rem;
      width: ${(props) => (props.showSearch ? "70vw" : "0")}!important;
    }
  }
`;

const Info = styled.div`
  position: absolute;
  display: none;
  top: 27px;
  font-size: 13px;
  font-size: bold;
  left: -18px;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  z-index: 2000;
  cursor: pointer;
  border: 1px solid #f8e8f1;
  height: 20px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(40px);
`;

const HeaderIconContainer = styled.div`
  position: relative;
  &:hover ${Info} {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -webkit-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    padding: 7px;
    @media (max-width: 514px) {
      display: none;
    }
  }
  @media (max-width: 914px) {
    display: none;
  }
`;

const Cart = styled.div`
  position: relative;
  &:hover ${Info} {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -webkit-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    padding: 7px;
  }
  svg {
    @media (max-width: 440px) {
      margin-right: 17px !important;
    }
  }
`;
